/* eslint-disable no-unused-vars */
import { TextField } from "@mui/material";

export default function PText(props) {
  return (
    <TextField
      style={props.style}
      error={props.error && props.error.length > 0 ? true : false}
      readOnly={props.readOnly}
      helperText={props.error && props.error != " " ? props.error : ""}
      variant={props.variant ? props.variant : "outlined"}
      label={props.label ? props.label : ""}
      type={props.type ? props.type : "text"}
      value={props.value}
      autoFocus={props.autoFocus}
      onChange={(e) => {
        if (props.onChange) props.onChange(e);
      }}
      onKeyPress={(e) => {
        if (props.onKeyPressed) props.onKeyPressed(e);
      }}
      onKeyDown={(event) => {
        if (event.keyCode == 38 || event.keyCode == 40) {
          event.preventDefault();
        } else {
          if (props.onKeyDown) props.onKeyDown(event);
        }
      }}
      onFocus={(e) => {
        if (props.onFocus) props.onFocus(e);
      }}
      onBlur={(e) => {
        if (props.onBlur) props.onBlur(e);
      }}
      fullWidth={true}
      placeholder={props.placeholder}
      multiline={props.multiline ? props.multiline : false}
      rows={props.rows ? props.rows : 1}
      maxRows={props.maxRows ? props.maxRows : 1}
      InputProps={props.InputProps}
      InputLabelProps={props.InputLabelProps}
      disabled={props.disabled}
      sx={props.sx}
      onWheel={(e) => e.target.blur()}
      size={props.size}
    />
  );
}
